import { createSelector } from '@reduxjs/toolkit';
export const groupsReducer = (state) => state.reduxGroups;
export const groupsSelector = createSelector(groupsReducer, (reducer) => reducer.data);
